import { render, staticRenderFns } from "./ElementMessageBox.vue?vue&type=template&id=f8f1386e&scoped=true"
import script from "./ElementMessageBox.vue?vue&type=script&lang=js"
export * from "./ElementMessageBox.vue?vue&type=script&lang=js"
import style0 from "./ElementMessageBox.vue?vue&type=style&index=0&id=f8f1386e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f1386e",
  null
  
)

export default component.exports